import { useState, useEffect } from "react";
import "./../cars/carform.scss";
import {
  CancelButton,
  IconButton,
  LoadingButton,
  PrimaryButton,
} from "../../custom_components/customButton";
import { IoMdAddCircleOutline, IoMdCloseCircle } from "react-icons/io";
import { GoDeviceMobile } from "react-icons/go";
import { MdEmail } from "react-icons/md";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Col,
  Input,
  Row,
  Checkbox,
  Radio,
  Upload,
  message,
  Select,
} from "antd";
import { colorScheme } from "../../contants/variables";
import { error, success } from "../../contants/snackbars";
import { uploadImage } from "../../stores/api_calls/upload";
import { uploadFile } from "../../stores/api_calls/upload";
import { useLocation, useNavigate } from "react-router-dom";
import CustomVideoUploader from "./CustomVideoUploader";
import { fetchUsers } from "../../stores/api_calls/users";
import Kjur from "../../stores/utils/jwt";
import "./discover-video.scss";
import {
  addVideo,
  editVideo,
  fetchVideo,
} from "../../stores/api_calls/discover-videos";

const DiscoverVideoForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const [uploadLoading, setUploadLoading] = useState(false);
  const [coverImageList, setCoverImageList] = useState([]);
  const [dealers, setDealers] = useState({ loading: false, data: [] });
  const [isEdit, setIsEdit] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    dealerId: "",
    fullName: "",
    dealerMobileNumber: "",
    dealerEmail: "",
    role: "",
    // direct_seller: false,

    title: "",
    videoType: "local",
    videoUrl: "",
    videoDuration: "",
    coverImage: "",
    description: "",
    status: "processing",
    packageId: null,
    isVerified: false,
    isSendPoster: false,
    isSendAll: false,
    isSuperAdmin: false,
    contactNumber: "",
  });

  // const generateThumbnailFromUrl = (videoUrl, captureTime = 0) => {
  //   return new Promise((resolve, reject) => {
  //     const video = document.createElement("video");
  //     video.crossOrigin = "anonymous"; // important if video is on another domain

  //     video.src = videoUrl;
  //     video.preload = "auto";

  //     video.onloadeddata = () => {
  //       video.currentTime = captureTime;
  //     };

  //     video.onseeked = () => {
  //       const canvas = document.createElement("canvas");
  //       canvas.width = video.videoWidth;
  //       canvas.height = video.videoHeight;

  //       const ctx = canvas.getContext("2d");
  //       ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

  //       canvas.toBlob(
  //         (blob) => {
  //           resolve(blob);
  //         },
  //         "image/jpeg",
  //         0.8,
  //       );
  //     };

  //     video.onerror = reject;
  //   });
  // };

  const generateThumbnailFromUrl = (videoUrl, captureTime = 0) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      
      // Essential for cross-domain and background loading
      video.crossOrigin = "anonymous";
      video.preload = "auto";
      video.muted = true;
      video.playsInline = true;

      // Set a timeout to prevent the promise from hanging forever
      const timeout = setTimeout(() => {
        reject(new Error("Video thumbnail generation timed out"));
      }, 10000);

      video.onloadedmetadata = () => {
        // Now we know the video dimensions exist
        video.currentTime = captureTime;
      };

      video.onseeked = () => {
        clearTimeout(timeout);
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            // Cleanup to free memory
            video.src = "";
            video.load();

            if (!blob) {
              reject(new Error("Failed to generate thumbnail image"));
              return;
            }

            const thumbnailFile = new File(
              [blob],
              `discover-video-thumbnail-${Date.now()}.jpg`,
              { type: "image/jpeg" }
            );

            resolve(thumbnailFile);
          },
          "image/jpeg",
          0.8
        );
      };

      video.onerror = (e) => {
        clearTimeout(timeout);
        reject(new Error("Error loading video: " + e.message));
      };

      video.src = videoUrl;
      video.load(); // Explicitly trigger the load
    });
  };

  useEffect(() => {
    async function prepareThumbnailFromVideoUrl() {
      try {
        const thumbnailImage = await generateThumbnailFromUrl(form.videoUrl);

        const res = await uploadFile(thumbnailImage);
        if (res?.data?.success) {
          const coverImageUrl = res?.data?.data?.metadata?.file_url;
          setForm({ ...form, coverImage: coverImageUrl });
        }
      } catch (error) {
        console.log(error);
      }
    }

    if (form.videoUrl) {
      prepareThumbnailFromVideoUrl();
    }
  }, [form.videoUrl]);

  useEffect(() => {
    getDealers();
  }, []);

  useEffect(() => {
    if (location.pathname.includes("/edit")) {
      setIsEdit(true);
    }
  }, []);

  useEffect(() => {
    if (isEdit) {
      getVideoDetails();
    }
  }, [isEdit]);

  const getVideoDetails = async () => {
    setRequestLoading(true);

    const getVideo = fetchVideo(params.get("id"));
    getVideo
      .then((res) => {
        if (res.data.success) {
          const parsedData = res.data.data;

          setForm({
            ...form,
            id: parsedData.id,

            dealerId: parsedData.advertisement_contact_details?._id ?? "",
            fullName: parsedData.advertisement_contact_details?.name,
            dealerEmail:
              parsedData.advertisement_contact_details?.user_contact_emails
                ?.email,
            dealerMobileNumber:
              parsedData.advertisement_contact_details?.user_contact_numbers
                ?.number,
            role:
              parsedData.advertisement_contact_details?.role_name ?? "Dealer",
            // direct_seller: parsedData.advertisement_contact_details?.direct_seller,

            title: parsedData.title,
            videoType: parsedData.video_type,
            videoUrl: parsedData.video_url,
            videoDuration: parsedData.video_duration,
            // coverImage: parsedData.cover_image,
            description: parsedData.description,
            status: parsedData.status,
            packageId: parsedData.package_id ?? null,
            isVerified: parsedData.is_verified,
            // isSendPoster: parsedData.is_send_poster,
            // isSendAll: parsedData.is_send_all,
            isSuperAdmin: parsedData.is_super_admin,
            contactNumber: parsedData.contact_number,
          });
          setRequestLoading(false);
        }
      })
      .catch((e) => console.log(e));
  };

  const validate = () => {
    let newErrors = {};

    const contactNumberRegex = /^[98753]\d{8}$/;

    if (form.isSuperAdmin) {
      const contact = form.contactNumber?.trim();
      if (!contact) {
        newErrors.contactNumber = "Contact Number is required";
      } else if (!contactNumberRegex.test(contact)) {
        newErrors.contactNumber =
          "Contact Number must be 9 digits and start with 3, 5, 7, 8, or 9";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = async () => {
    if (!validate()) return;

    setRequestLoading(true);

    if (!isEdit) {
      handleAddVideo();
    } else {
      handleUpdateVideo();
    }
  };

  const handleAddVideo = () => {
    const createVideo = addVideo({ ...form });
    createVideo
      .then((res) => {
        if (res.data.success) {
          success("Discover Video has been added successfully!");
          setRequestLoading(false);
          navigate("../discover-videos/verified", { replace: true });
        }
      })
      .catch((e) => {
        setForm({ ...form });
        error("Failed to add video");
        console.log("error");
        setRequestLoading(false);
      });
  };

  const handleUpdateVideo = () => {
    const updateVideo = editVideo({ ...form });
    updateVideo
      .then((res) => {
        if (res.data.success) {
          success("Discover Video has been updated successfully!");
          setRequestLoading(false);
          navigate("../discover-videos/verified", { replace: true });
        }
      })
      .catch((e) => {
        setForm({ ...form });
        error("Failed to update video");
        console.log("error");
        setRequestLoading(false);
      });
  };

  const onCancel = () => {
    if (form.status === "verified") {
      navigate("../discover-videos/verified", { replace: true });
    } else if (form.status === "processing") {
      navigate("../discover-videos/unverified", { replace: true });
    } else {
      navigate("../discover-videos/draft", { replace: true });
    }
  };

  const handleFieldChange = (name, e) => {
    const value = e.target.value;

    if (name === "contactNumber") {
      const phone = value.replace(/\D/g, "");
      setForm({ ...form, [name]: phone });
    } else {
      setForm({ ...form, [name]: value });
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const onCheckboxChange = (name, e) => {
    setForm({
      ...form,
      [name]: e.target.checked,
    });
  };

  const handleDropdownChange = (name, value) => {
    setForm({
      ...form,
      [name]: value,
    });
  };

  const handelVideoChange = (key, value, thumbnail) => {
    //   setForm({ ...form, [key]: value });
    setForm((prev) => ({
      ...prev,
      [key]: value,
      coverImage: thumbnail || null,
    }));
  };

  const handleRadioChange = (key, e) => {
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const contactNumberRegex = /^[98753]\d{8}$/;

  const handleBlur = (name) => {
    if (name === "contactNumber" && form.isSuperAdmin) {
      if (!form.contactNumber) {
        setErrors((prev) => ({
          ...prev,
          contactNumber: "Contact Number is required",
        }));
      } else if (!contactNumberRegex.test(form.contactNumber)) {
        setErrors((prev) => ({
          ...prev,
          contactNumber:
            "Contact Number must be 9 digits and start with 3, 5, 7, 8, or 9",
        }));
      }
    }
  };

  // const uploadButton = (
  //       <button style={{ border: 0, background: 'none' }} type="button">
  //       {uploadLoading ? <LoadingOutlined /> : <PlusOutlined />}
  //       <div style={{ marginTop: 8 }}>Upload</div>
  //       </button>
  // );

  // const beforeUploadCoverImage = (file) => {
  //   const isImageOrPdf = file.type.startsWith('image/');
  //   if (!isImageOrPdf) {
  //       message.error('You can only upload image (PNG or JPG)!');
  //       return Upload.LIST_IGNORE;
  //   }
  //   const isLt10M = file.size / 1024 / 1024 < 1;
  //   if (!isLt10M) {
  //       message.error('File must be smaller than 1MB!');
  //       return Upload.LIST_IGNORE;
  //   }

  //   // return false;
  //   return isImageOrPdf && isLt10M;
  // };

  // const handleChangeCoverImage = ({ fileList: newFileList }) => {
  //   setCoverImageList(newFileList);
  // };

  // const handleUploadCoverImage = async (options) => {
  //   console.log('start upload');
  //   const { file, onProgress, onError, onSuccess } = options;

  //   try {
  //     const res = await uploadFile(file);
  //     console.log(res.data);
  //     if (res?.data?.success) {
  //       onSuccess(res.data.data);

  //       const coverImageUrl = res?.data?.data?.metadata?.file_url;
  //       // handelVideoChange("coverImage", coverImageUrl);
  //       setForm({ ...form, coverImage: coverImageUrl });

  //     } else {
  //       throw new Error('Upload failed');
  //     }
  //   } catch (error) {
  //     onError(error);
  //     message.error('Upload failed attach logcard!');
  //     console.error(error);
  //   }
  // };

  const getDealers = () => {
    setDealers({ ...dealers, loading: true });
    const pagination = {
      page: 1,
      limit: 100000,
      keyword: "",
      roleIds: ["619e5d55e7040000a2007b08", "619e5d67e7040000a2007b09"],
      isVerified: true,
    };

    const users = fetchUsers(pagination);
    users
      .then((res) => {
        if (res.data.success) {
          setDealers({ ...dealers, loading: false, data: res.data.data });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (form.dealerId) {
      dealers.data.forEach((dealer) => {
        if (dealer._id === form.dealerId) {
          setForm({
            ...form,
            dealerMobileNumber: dealer.user_contact_numbers
              ?.filter((el) => el.is_active === true)
              .map((el) => el.number),
            dealerEmail: dealer.user_contact_emails
              ?.filter((el) => el.is_active === true)
              .map((el) => el.email),
            role: dealer.user_role,
          });
        }
      });
    }
  }, [form.dealerId]);

  function isValidSingaporePhoneNumber(phoneNumber) {
    const regex = /^[278]\d{6}$/;
    return regex.test(phoneNumber);
  }

  return (
    <div className="form-table-container">
      <div className={`table-title-icon ${!isEdit ? "add" : "edit"}`}>
        <IoMdAddCircleOutline />
      </div>
      <p className={`table-title-text ${!isEdit ? "add" : "edit"}`}>
        {!isEdit ? "Add Discover Video" : `Edit Discover Video`}
      </p>

      <div className="form-body-container">
        <Row>
          <Col span={24} lg={8}>
            <div className="form-fields">
              <p className="form-field-label">
                Name <span>*</span> :{" "}
              </p>
              <Select
                showSearch
                value={form.fullName || undefined}
                loading={dealers.loading}
                onChange={(value) => handleDropdownChange("dealerId", value)}
                style={{ width: "100%" }}
                placeholder="Search to Select"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {[...dealers.data].map((el, i) => (
                  <Select.Option key={i} value={el._id}>
                    {`${el.user_first_name} ${el.user_last_name}`}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={24} lg={8}>
            <div className="form-fields">
              <p className="form-field-label">
                Mobile Number <span>*</span> :{" "}
              </p>
              <Input
                value={form.dealerMobileNumber}
                prefix={<GoDeviceMobile />}
                onChange={(text) =>
                  handleFieldChange("dealerMobileNumber", text)
                }
                disabled={
                  form.dealerId === "0" || form.dealerId === "1" ? false : true
                }
              />
            </div>
          </Col>
          <Col span={24} lg={8}>
            <div className="form-fields">
              <p className="form-field-label">Email:</p>
              <Input
                value={form.dealerEmail}
                prefix={<MdEmail />}
                onChange={(text) => handleFieldChange("dealerEmail", text)}
                disabled={
                  form.dealerId === "0" || form.dealerId === "1" ? false : true
                }
              />
            </div>
          </Col>
        </Row>

        <Row gutter={[15, 15]}>
          <Col span={24} lg={16}>
            <div className="form-fields">
              <p className="form-field-label">
                Video Title <span>*</span> :{" "}
              </p>
              <Input
                placeholder="Video Title"
                maxLength={100}
                value={form.title}
                onChange={(text) => handleFieldChange("title", text)}
              />
              <p style={{ textAlign: "right" }}>
                {form.title ? form.title.length : 0}/100
              </p>
            </div>
          </Col>
        </Row>

        <Row gutter={[15, 15]}>
          <Col span={24} lg={12} xl={12}>
            <div className="form-fields">
              <p className="form-field-label">
                Video Links <span style={{ color: "red" }}> * </span>:
              </p>
              <div style={{ fontSize: 14, color: "red", fontWeight: "600" }}>
                <span>
                  {" "}
                  We shall not be held responsible for all videos done by you.
                </span>{" "}
                <br />
                <span>
                  {" "}
                  Your video is subject for review. You can only list your video
                  once and it is not changable.
                </span>
              </div>

              {isEdit ? (
                <>
                  {form.videoUrl && (
                    <div style={{ marginLeft: "20px", display: "flex" }}>
                      <video
                        src={form.videoUrl}
                        controls
                        width="150"
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                  )}
                </>
              ) : (
                <CustomVideoUploader
                  videoUrl={form.videoUrl}
                  handelVideoChange={handelVideoChange}
                />
              )}
            </div>
          </Col>

          {/* <Col span={24} lg={12} xl={12}>
              <div className="form-fields">
                <p className="form-field-label">
                    Upload Cover Image :{" "}
                </p>
                <div style={{ fontSize: 14 }}>
                    File size can not exceed <strong>1MB per image</strong> and it's dimension should not exceed <strong> (220 x 260)pixels</strong>.
                    <br /> <span style={{ color: 'red', fontWeight: 'bold' }}> Only PNG & JPG images are allowed.</span>
                </div>

                <Upload
                listType="picture-card"
                className="avatar-uploader"
                style={{overflow:'hidden'}}
                beforeUpload={beforeUploadCoverImage}
                onChange={handleChangeCoverImage}
                customRequest={handleUploadCoverImage}
                showUploadList={false}
                fileList={coverImageList}
                multiple={false}
                accept="image/*"
                maxCount={1}
                >
                    {form.coverImage ? (
                    <img draggable={false} src={form.coverImage} alt="avatar" style={{ width: '100%' }} />
                    ) : (
                    uploadButton
                    )}
                </Upload>

              </div>
          </Col> */}
        </Row>

        <Row gutter={[15, 15]}>
          <Col span={24} lg={8}>
            <div className="form-container" style={{ marginTop: 10 }}>
              <Checkbox
                valuePropName="checked"
                checked={form.isSuperAdmin}
                onChange={(e) => onCheckboxChange("isSuperAdmin", e)}
              >
                Is Super Admin
              </Checkbox>
            </div>
          </Col>

          {form.isSuperAdmin && (
            <Col span={24} lg={8}>
              <div className="form-fields">
                <p className="form-field-label">
                  Contact Number <span>*</span> :{" "}
                </p>
                <p style={{ width: "100%" }}>
                  <small>
                    Please insert phone number only start with <b>3</b> or{" "}
                    <b>5</b> or <b>7</b> or <b>8</b> or <b>9</b> and must be{" "}
                    <b> Nine </b> digits.
                  </small>
                </p>
                <Input
                  placeholder="Contact Number"
                  value={form.contactNumber}
                  onChange={(text) => handleFieldChange("contactNumber", text)}
                  onBlur={() => handleBlur("contactNumber")}
                  maxLength={9}
                  status={errors.contactNumber ? "error" : ""}
                />

                {errors.contactNumber && (
                  <span style={{ color: "red" }}>{errors.contactNumber}</span>
                )}
              </div>
            </Col>
          )}
        </Row>

        <Row gutter={[15, 15]}>
          <Col span={24} lg={16}>
            <div className="form-fields">
              <p className="form-field-label">
                Description <span></span> :{" "}
              </p>
              <Input.TextArea
                rows={5}
                value={form.description}
                onChange={(text) => handleFieldChange("description", text)}
              />
            </div>
          </Col>
        </Row>

        {form.status != "draft" && (
          <Row gutter={[15, 15]}>
            <Col span={24} md={6}>
              <div className="form-container">
                <Checkbox
                  valuePropName="checked"
                  checked={form.isVerified}
                  onChange={(e) => onCheckboxChange("isVerified", e)}
                >
                  Is Verified
                </Checkbox>
              </div>
            </Col>
            <Col span={24} md={6}>
              <div className="form-container">
                <Checkbox
                  valuePropName="checked"
                  checked={form.isSendPoster}
                  onChange={(e) => onCheckboxChange("isSendPoster", e)}
                >
                  Send to poster only
                </Checkbox>
              </div>
            </Col>
            <Col span={24} md={6}>
              <div className="form-container">
                <Checkbox
                  valuePropName="checked"
                  checked={form.isSendAll}
                  onChange={(e) => onCheckboxChange("isSendAll", e)}
                >
                  Send to all email sub
                </Checkbox>
              </div>
            </Col>
          </Row>
        )}
      </div>

      <div
        className="btn-div"
        style={{
          marginTop: 30,
          marginBottom: 20,
          display: "flex",
          justifyContent: "end",
          gap: 20,
        }}
      >
        <div className="btn">
          <CancelButton
            bgColor={colorScheme.offwhite}
            textColor={colorScheme.black}
            label="Cancel"
            onClick={() => onCancel()}
          />
        </div>
        <div className="btn">
          {requestLoading ? (
            <LoadingButton />
          ) : (
            <PrimaryButton
              label={isEdit ? "Update Video" : "Create Video"}
              color={colorScheme.primary}
              onClick={() => onSubmit()}
              disabled={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DiscoverVideoForm;
